export default "__VITE_ASSET__BevICV5R__"